import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = "Hapus", onConfirm, testId = "confirm-dialog" }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="rounded-2xl" data-testid={testId}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-xl" data-testid={`${testId}-cancel`}>Batal</AlertDialogCancel>
        <AlertDialogAction className="rounded-xl bg-rose-600 hover:bg-rose-700" onClick={onConfirm} data-testid={`${testId}-confirm`}>
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
